import { Message } from "@cnx/common";
import { useEffect, useState } from "react";
import { useAuthStore } from "stores/authStore";
import { useChatContextStore } from "../providers/ChatContextProvider";

export const useFirstUnreadMessage = (messages: Message[]) => {
  const { discussionId } = useChatContextStore();
  const currentUserId = useAuthStore(state => state.currentUserId);
  const [firstUnreadMessageId, setFirstUnreadMessageId] = useState<
    string | null | undefined
  >(undefined);

  useEffect(() => {
    setFirstUnreadMessageId(undefined);
  }, [discussionId]);

  useEffect(() => {
    if (messages.length === 0) return;
    if (firstUnreadMessageId !== undefined) return;

    const lastMessage = messages[messages.length - 1];
    if (lastMessage.createdBy === currentUserId) {
      setFirstUnreadMessageId(null);
      return;
    }

    const firstUnread = messages.find(
      message =>
        message.createdBy !== currentUserId &&
        message.recipients?.some(
          recipient =>
            recipient.read === null ||
            (recipient.read === undefined && recipient.userId === currentUserId)
        )
    );

    setFirstUnreadMessageId(firstUnread?.id ?? null);
  }, [messages, currentUserId, firstUnreadMessageId]);

  return { firstUnreadMessageId, setFirstUnreadMessageId };
};
